// extracted by mini-css-extract-plugin
export default {"table":"Table_table__R0zc7","td":"Table_td__A5o2v","th":"Table_th__ffri+","tr":"Table_tr__dfBy1"};